import { useParams } from 'react-router-dom';

export const useLedgerId = () => useParams<Dictionary<string>>().id!;
